import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-screw"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill\"></rect><rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill icon-fi--filled\"></rect><g transform=\"translate(-2 1)\" class=\"\"><path d=\"M14,14.6l9-4.6l9,4.6v10.4L23,30l-9-4.9V14.6z\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></path><ellipse cx=\"23\" cy=\"20\" class=\"icon-fi--no-fill icon-fi--with-stroke\" rx=\"8\" ry=\"8\"></ellipse></g>", 3)
  ]), 16))
}
export default { render: render }